/* @flow */
import * as breakpoints from "../breakpoints";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { GUTTER_WIDTH } from "./Container";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	row: {
		marginLeft: -(GUTTER_WIDTH / 2),
		marginRight: -(GUTTER_WIDTH / 2),

		":after": {
			content: '""',
			display: "table",
			clear: "both",
		},
	},
	largeMatchHeight: {
		[breakpoints.desktopOnly]: {
			display: "flex",
			alignItems: "stretch",
		},
	},
	mediumMatchHeight: {
		[breakpoints.tabletOnly]: {
			display: "flex",
			alignItems: "stretch",
		},
	},
	smallMatchHeight: {
		[breakpoints.mobileOnly]: {
			display: "flex",
			alignItems: "stretch",
		},
	},
});

// Row is used inside of a Container or Column component, and should only contain Columns
export default class Row extends PureComponent {
	static propTypes = {
		children: PropTypes.node.isRequired,
		className: PropTypes.string,
		largeMatchHeight: PropTypes.bool.isRequired,
		mediumMatchHeight: PropTypes.bool.isRequired,
		smallMatchHeight: PropTypes.bool.isRequired,
		style: PropTypes.object,
	};

	static defaultProps = {
		largeMatchHeight: false,
		mediumMatchHeight: false,
		smallMatchHeight: false,
	};

	render() {
		const args = [
			styles.row,
			this.props.largeMatchHeight && styles.largeMatchHeight,
			this.props.mediumMatchHeight && styles.mediumMatchHeight,
			this.props.smallMatchHeight && styles.smallMatchHeight,
		];

		const finalClassName = this.props.className
			? `${css(...args)} ${this.props.className}`
			: css(...args);

		return (
			<div className={finalClassName} style={this.props.style}>
				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/grid/Row.js